/* ==========================================================================
   GUÍA DE TALLAS - FICHA POR TALLA (mobile)

   Comportamiento de la ficha que renderiza snippets/size-guide-table.liquid.
   Vive en un asset compartido porque las mismas tablas se muestran en dos
   lugares: el modal de la ficha de producto (snippets/size_guide.liquid) y la
   página de guía de tallas (templates/page.size_guide.liquid).
   ========================================================================== */

// Los chips y los paneles se emparejan por índice dentro de su propia ficha:
// el chip N muestra el panel N de esa misma [data-size-card]. Se resuelve por
// ficha y no por documento porque la página de guía de tallas muestra dos
// tablas a la vez (recién nacida/o y niña/o), y los índices se repiten entre
// ellas.
function sizeGuideSelectSize(card, index) {
  if (!card) return;
  card.querySelectorAll('[data-size-chip]').forEach((chip) => {
    const on = chip.dataset.sizeChip === String(index);
    chip.classList.toggle('is-active', on);
    chip.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  card.querySelectorAll('[data-size-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.sizePanel !== String(index);
  });
}

document.addEventListener('click', (e) => {
  const chip = e.target.closest('[data-size-chip]');
  if (chip) sizeGuideSelectSize(chip.closest('[data-size-card]'), chip.dataset.sizeChip);
});

/* --------------------------------------------------------------------------
   Cruz de lectura (desktop)

   Con siete u ocho columnas de números, seguir el renglón de una talla hasta
   "Contorno cadera" es fácil de perder. Al apuntar una celda se marcan su fila
   y su columna. Solo con mouse: en touch el hover se queda pegado después del
   toque y quedaría una marca que nadie pidió.
   -------------------------------------------------------------------------- */

const SIZE_TABLE_CELL = '.size-table td, .size-table th';

function sizeTableClearHighlight(table) {
  table.querySelectorAll('.is-hl-col, .is-hl-cell, .is-hl-row').forEach((el) => {
    el.classList.remove('is-hl-col', 'is-hl-cell', 'is-hl-row');
  });
}

// La fila de encabezados y la columna de tallas son el marco de la tabla: son
// la referencia fija con la que se lee el resto, así que no se marcan.
function sizeTableIsFrameCell(cell) {
  const table = cell.closest('.size-table');
  if (!table) return true;
  if (table.classList.contains('size-table--columns')) {
    return cell.cellIndex === 0 || cell.parentElement.rowIndex === 0;
  }
  return !!cell.closest('thead') || cell.cellIndex === 0;
}

function sizeTableHighlight(cell) {
  const table = cell.closest('.size-table');
  if (!table) return;
  sizeTableClearHighlight(table);
  if (sizeTableIsFrameCell(cell)) return;
  cell.parentElement.classList.add('is-hl-row');
  table.querySelectorAll('tr').forEach((row) => {
    const target = row.cells[cell.cellIndex];
    if (target) target.classList.add('is-hl-col');
  });
  cell.classList.add('is-hl-cell');
}

if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.addEventListener('mouseover', (e) => {
    const cell = e.target.closest(SIZE_TABLE_CELL);
    if (cell) sizeTableHighlight(cell);
  });

  document.addEventListener('mouseout', (e) => {
    const table = e.target.closest('.size-table');
    if (table && !table.contains(e.relatedTarget)) sizeTableClearHighlight(table);
  });
}

/* --------------------------------------------------------------------------
   Talla fijada

   Un clic deja una talla marcada, para no perderla mientras se comparan las
   demás o se lee el resto de la página. En la tabla de calzado las tallas son
   columnas (orientation: 'columns'), así que ahí se fija la columna.
   -------------------------------------------------------------------------- */

function sizeTablePinKey(cell) {
  const table = cell.closest('.size-table');
  if (!table) return null;
  if (table.classList.contains('size-table--columns')) {
    // La primera columna son las etiquetas de cada medida, no una talla.
    return cell.cellIndex === 0 ? null : 'c' + cell.cellIndex;
  }
  return cell.closest('thead') ? null : 'r' + cell.parentElement.rowIndex;
}

function sizeTableClearPin(table) {
  table.querySelectorAll('.is-pinned').forEach((el) => el.classList.remove('is-pinned'));
  delete table.dataset.pinned;
}

function sizeTableSetPin(cell) {
  const table = cell.closest('.size-table');
  const key = sizeTablePinKey(cell);
  if (!table || !key) return;
  sizeTableClearPin(table);
  table.dataset.pinned = key;
  if (key[0] === 'c') {
    table.querySelectorAll('tr').forEach((row) => {
      const target = row.cells[cell.cellIndex];
      if (target) target.classList.add('is-pinned');
    });
  } else {
    cell.parentElement.classList.add('is-pinned');
  }
}

document.addEventListener('click', (e) => {
  const cell = e.target.closest(SIZE_TABLE_CELL);
  if (!cell) return;
  const table = cell.closest('.size-table');
  const key = sizeTablePinKey(cell);
  if (!key) return;
  // Volver a hacer clic en lo mismo lo suelta.
  if (table.dataset.pinned === key) sizeTableClearPin(table);
  else sizeTableSetPin(cell);
});

// Fija la talla por su texto ("6A", "22"). Lo usa el modal de la ficha de
// producto para que la tabla arranque marcando la talla que el cliente eligió.
function sizeGuidePinSizeValue(root, value) {
  if (!root || !value) return;
  root.querySelectorAll('.size-table').forEach((table) => {
    const byColumn = table.classList.contains('size-table--columns');
    const cells = byColumn
      ? Array.from(table.querySelector('tr').cells)
      : Array.from(table.querySelectorAll('tbody tr')).map((row) => row.cells[0]);
    const match = cells.find((cell) => cell && cell.textContent.trim().toUpperCase() === value);
    if (match) sizeTableSetPin(match);
    else sizeTableClearPin(table);
  });
}
